/* eslint-disable */
import { React, useState, useEffect} from 'react';
import { Grid, Box, Typography, Button, typographyClasses } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { ClipLoader } from "react-spinners";

import CustomTextField from '../../components/forms/custom-elements/CustomTextField';
import CustomFormLabel from '../../components/forms/custom-elements/CustomFormLabel';
import PageContainer from '../../components/container/PageContainer';

import img1 from '../../assets/images/backgrounds/login-bg.svg';
import LogoIcon from '../../layouts/full-layout/logo/LogoIcon';
import { register } from '../../actions/AuthenticationActions';
import RegisterError from '../../components/alerts/RegisterError';
import { CLR_AUTH_MSGS } from '../../redux/constants';
 
const Register = () => {
    const [registerEmail, setRegisterEmail] = useState("");
    const [registerPassword, setRegisterPassword] = useState("");
    const [registerConfirmPassword, setRegisterConfirmPassword] = useState("");
    const [awaitingResponse, setAwaitingResponse] = useState(false);

    const errorsArray = useSelector(state => state.Authentication.errors);

    const dispatch = useDispatch();

    const onRegisterSubmit = (e) => {
        e.preventDefault();

        //show spinner on button
        setAwaitingResponse(true);

        const formData = {
            email: registerEmail,
            password: registerPassword,
            confirmationPassword: registerConfirmPassword
        }

        dispatch(register(formData));
    }

    const onRegisterEmailChange = (e) => {
        setRegisterEmail(e.target.value);
    }

    const onRegisterPasswordChange = (e) => {
        setRegisterPassword(e.target.value);
    }

    const onRegisterConfirmPasswordChange = (e) => {
        setRegisterConfirmPassword(e.target.value);
    }

    /* clear authentication mssgs to that they wont 
        show on next instantiation of this component */
    useEffect( () => {
        return () => dispatch({
            type: CLR_AUTH_MSGS,
        })
    }, [])

    /* stop the spinner if we get errors back 
        after submitting the form */
    useEffect(() => {
        if(errorsArray?.length > 0){
            setAwaitingResponse(false);
        }
    })

    return (
        <PageContainer title="Register" description="this is Register page">
            <Grid container spacing={0} sx={{ height: '100vh', justifyContent: 'center' }}>
                <Grid
                    item
                    xs={12}
                    sm={12}
                    lg={6}
                    sx={{
                        background: (theme) => `${theme.palette.mode === 'dark' ? '#1c1f25' : '#ffffff'}`,
                    }}
                >
                    <Box
                        sx={{
                            position: 'relative',
                        }}
                    >
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            sx={{
                                position: {
                                    xs: 'relative',
                                    lg: 'absolute',
                                },
                                height: { xs: 'auto', lg: '100vh' },
                                right: { xs: 'auto', lg: '-50px' },
                                margin: '0 auto',
                            }}
                        >
                            <img
                                src={img1}
                                alt="bg"
                                style={{
                                    width: '100%',
                                    maxWidth: '812px',
                                }}
                            />
                        </Box>

                        <Box
                            display="flex"
                            alignItems="center"
                            sx={{
                                p: 4,
                                position: 'absolute',
                                top: '0',
                            }}
                        >
                            {/* <LogoIcon /> */}
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={8} lg={6} display="flex" alignItems="center">
                    <Grid container spacing={0} display="flex" justifyContent="center">
                        <Grid item xs={12} lg={9} xl={6}>
                            <Box
                                sx={{
                                    p: 4,
                                }}
                            >
                                <Typography fontWeight="700" variant="h2">
                                    Welcome to Capsule
                                </Typography>
                                <Box display="flex" alignItems="center">
                                    <Typography
                                        color="textSecondary"
                                        variant="h6"
                                        fontWeight="400"
                                        sx={{
                                            mr: 1,
                                        }}
                                    >
                                        Already have an Account?
                                    </Typography>
                                    <Typography
                                        component={Link}
                                        to="/login"
                                        fontWeight="500"
                                        sx={{
                                            display: 'block',
                                            textDecoration: 'none',
                                            color: 'primary.main',
                                        }}
                                    >
                                        Sign In
                                    </Typography>
                                </Box>
                                <Box
                                    sx={{
                                        mt: 4,
                                    }}
                                >
                                    {errorsArray?.map((item, index) => {
                                        return <RegisterError message={item.msg} key={index} />
                                    })}
                                    <CustomFormLabel htmlFor="email">Email Address</CustomFormLabel>
                                    <CustomTextField id="email" variant="outlined" fullWidth onChange={onRegisterEmailChange} />
                                    <CustomFormLabel htmlFor="password">Password</CustomFormLabel>
                                    <CustomTextField
                                        id="password"
                                        variant="outlined"
                                        type="password"
                                        onChange={onRegisterPasswordChange}
                                        fullWidth
                                        sx={{
                                            mb: 3,
                                        }}
                                    />
                                    <CustomFormLabel htmlFor="confirmationPassword">Confirmation Password</CustomFormLabel>
                                    <CustomTextField
                                        id="confirmationPassword"
                                        variant="outlined"
                                        type="password"
                                        onChange={onRegisterConfirmPasswordChange}
                                        fullWidth
                                        sx={{
                                            mb: 3,
                                        }}
                                    />


                                    <Button
                                        color="secondary"
                                        variant="contained"
                                        size="large"
                                        onClick={onRegisterSubmit}
                                        fullWidth
                                        sx={{
                                            pt: '10px',
                                            pb: '10px',
                                        }}
                                    >
                                        {awaitingResponse ? <ClipLoader color='white' loading={awaitingResponse} /> : "Sign Up"}
                                    </Button>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </PageContainer >)
};

export default Register;
